const NoteIcons = () => {
	return (
		<svg
		className="inline ml-1"
			width="18"
			height="18"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M6 4C5.44772 4 5 4.44772 5 5V19C5 19.5523 5.44772 20 6 20H18C18.5523 20 19 19.5523 19 19V12C19 11.4477 19.4477 11 20 11C20.5523 11 21 11.4477 21 12V19C21 20.6569 19.6569 22 18 22H6C4.34315 22 3 20.6569 3 19V5C3 3.34315 4.34315 2 6 2H12C12.5523 2 13 2.44772 13 3C13 3.55228 12.5523 4 12 4H6Z"
				fill="#33383F"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M8.06411 11.6638C7.91111 11.8168 7.81187 12.0153 7.78127 12.2295L7.30986 15.5293C7.21558 16.1893 7.78127 16.755 8.44123 16.6607L11.7411 16.1893C11.9553 16.1587 12.1538 16.0594 12.3068 15.9064L19.8492 8.36397C21.0208 7.19239 21.0208 5.2929 19.8492 4.12132C18.6776 2.94975 16.7782 2.94975 15.6066 4.12132L8.06411 11.6638ZM16.3137 9.07108L11.1282 14.2565L9.47832 14.4922L9.71403 12.8423L14.8995 7.65686L16.3137 9.07108ZM17.7279 7.65686L16.3137 6.24265L17.0208 5.53554C17.4113 5.14501 18.0445 5.14501 18.435 5.53554C18.8255 5.92606 18.8255 6.55923 18.435 6.94975L17.7279 7.65686Z"
				fill="#33383F"
			/>
		</svg>
	);
};
export default NoteIcons;
